import { ServiceRestApi } from "./service-rest-api";
import axios from "axios";
import jwtWorker from "utils/jwt-worker";
import { CUSTOM_MESSAGES } from "utils";

const [downloadAxiosInstance, reportingAxiosInstance] = [axios.create(), axios.create()];
downloadAxiosInstance.interceptors.request.use(
    async (config) => {
        config.baseURL = `${process.env.REACT_APP_API_URL}-reporting/api/reporting`;
        config.headers.Authorization = jwtWorker.getTokenFromStorage();
        config.responseType = 'blob';
        return config;
    },
    error => Promise.reject(error)
);

reportingAxiosInstance.interceptors.request.use(
    async (config) => {
        config.baseURL = `${process.env.REACT_APP_API_URL}-reporting/api/reporting`;
        config.timeout = 60000;
        config.headers.Authorization = jwtWorker.getTokenFromStorage();
        return config;
    },
    error => Promise.reject(error)
);

class ReportingService {

    cacheUtility = {};
    httpService = new ServiceRestApi(reportingAxiosInstance);

    getFilterPrerequistes = () => {
        let suffix = '/filters-prerequisites';
        if (!this.cacheUtility[suffix]) this.cacheUtility[suffix] = this.httpService.get(suffix);
        return this.cacheUtility[suffix];
    }

    getInterventionActivityKPIs = (params) => {
        return this.httpService.get(`/intervention-activity?${params}`, true);
    }

    getClientActivityKPIs = (params) => {
        return this.httpService.get(`/intervention-client-activity?${params}`);
    }

    getInterventionActivityByCategory = (params) => {
        return this.httpService.get(`/tags-categorization?${params}`);
    }

    getGlobalStats = (params) => {
        return this.httpService.get(`/global-stats?${params}`);
    }

    getTotalTasksByDelay = (params) => {
        return this.httpService.get(`/intervention-status-delai?${params}`)
    }

    getInterventionDailyActivity = (params) => {
        return this.httpService.get(`/intervention-daily-activity?${params}`);
    }

    getAgentActivity = (params) => {
        return this.httpService.get(`/agent-activity?${params}`)
    }

    getInterventionAVGResponse = (params) => {
        return this.httpService.get(`/intervention-average-response-time?${params}`)
    }

    getAgentsLoggedIn = () => {
        return this.httpService.get(`/logged-users`);
    }

    /********************************* DOWNLOAD HTTP SERVICE *********************************/

    downloadKpiReport = (suffix, params, extension) => new Promise((resolve, reject) => {
        downloadAxiosInstance.get(`/${suffix}?${params}&fileExtension=${extension}`).then(response => {
            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                let filename = suffix;
                link.setAttribute('download', filename + '.' + extension);
                document.body.appendChild(link);
                link.click();
                resolve(CUSTOM_MESSAGES.SUCCESS_DOWNLOAD_MESSAGE);
            } else {
                reject(response?.data?.message !== undefined ? response.data.message : CUSTOM_MESSAGES.SMTHG_WRONG_MESSAGE);
            }
        }, error => {
            reject(error.message);
        })
    })

}
export default new ReportingService();